import { forwardRef, useCallback } from "react"

import { SelectX } from "web/components"

import { useFieldSuggestedValues } from "web/hooks/data"

import { isNotAValue } from "web/services/helpers"

import ControlContainer from "./ControlContainer"

const ListInput = forwardRef((props, ref) => {
  const {
    id,
    name,
    value,
    error,
    touched,
    onChange,
    onFocus,
    autoFocus,
    disabled = false,
    allowQuickAdd = true,
  } = props

  const suggestedValues = useFieldSuggestedValues({ id })

  const encodedSuggestedValues = useCallback(
    async (hint) => {
      return (await suggestedValues(hint)).map((el) => ({
        value: el,
        label: el,
      }))
    },
    [suggestedValues]
  )

  async function handleQuickAdd(textToAdd) {
    const valueToAdd = { value: textToAdd, label: textToAdd, kind: "Text" }
    onChange([...(value || []), valueToAdd])
  }

  function handleSelectXChange(value) {
    if (value === null) {
      onChange(null)
    } else {
      onChange(
        value.map((value) => ({ ...value, kind: "Text", format: "Text" }))
      )
    }
  }

  const selectXValue =
    isNotAValue(value) || !Array.isArray(value)
      ? []
      : value.map((el) => ({ label: el.value, ...el }))

  return (
    <ControlContainer {...props} errorCondition={error && touched}>
      <SelectX
        ref={ref}
        name={name}
        value={selectXValue}
        suggestedValues={encodedSuggestedValues}
        onChange={handleSelectXChange}
        onFocus={onFocus}
        onAdd={allowQuickAdd ? handleQuickAdd : null}
        options={{
          multipleValues: true,
          inputClassName: "form-control",
          inputTestId: `form-input-${name}`,
          autoFocus,
          placeholder: "Select values...",
        }}
        disabled={disabled}
      />
    </ControlContainer>
  )
})

export default ListInput
